import ApiClient from '@/helpers/ApiClient';

class NotificationsApi extends ApiClient {
  constructor() {
    super('notifications');
  }
}

export default new NotificationsApi();
